import React from 'react';
import moment from 'moment';
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import Rdx from "../../../../../redux/Rdx";
import PencilIcon from "calcite-ui-icons-react/PencilIcon"; // EditAttributesIcon
import RecurrenceIcon from "calcite-ui-icons-react/RecurrenceIcon";

// 3rd party
import Loader from "calcite-react/Loader";
import Tooltip from "calcite-react/Tooltip";
import WarningIcon from "calcite-ui-icons-react/ExclamationMarkTriangleIcon";
import XIcon from "calcite-ui-icons-react/XIcon";
import ClockIcon from 'calcite-ui-icons-react/ClockIcon';
import PinIcon from 'calcite-ui-icons-react/PinIcon';

// aiim.base
import ItemReference from '../../../../../aiim/base/ItemReference';

// components.main.Actions.More.BookWorkspace.WorkspaceReservation
import { getHotelBookingSystem, getHotelBookingSystemType } from './WorkspaceReservation/workspaceReservationUtil';
import * as workspaceReservationUtil from "./WorkspaceReservation/workspaceReservationUtil";
import { getBookings, cancelBooking} from "./WorkspaceReservation/OfficeHotelingInterface";
import Office365 from './WorkspaceReservation/Office365';

// components.util
import * as component from '../../../../util/component';

// util
import { stringFormatter } from '../../../../../util/formatUtil';

// context
import Context from '../../../../../context/Context';
import Topic from '../../../../../context/Topic';

// common/components/Modal
import { ModalController }  from "../../../../../common/components/Modal/index";
import BookingDetails from './BookingDetails';
import BookingCancel from './BookingCancel';
import * as validateUtil from './validateUtil';
import * as dateUtil from '../../../Events/dateUtil';

import { getAttributeValue } from '../../../../../aiim/util/aiimUtil';
import FieldNames from '../../../../../aiim/datasets/FieldNames';
import BookingConfirmed from './BookingConfirmed';
import Schedule from '../../../MeetingRooms/Schedule';
import Icons from '../../../../util/Icons';
import RecurrenceDropdown from './RecurrenceDropdown';

const CSS = {
  bookingCardList: "i-booking-card-list",
  bookingCard: "i-booking-card",
  bookingInfoLine: "i-booking-info-line",
  locationDescription: "i-booking-location-description",
  button: "i-book-button",
  buttonCheckIn: "i-book-card-button-checkIn",
  buttonCheckOut: "i-book-card-button-checkOut",
  actionGroup: "i-action-group i-my-bookings",
  actionSubGroup: "i-action-subgroup",
  cancel: "i-booking-cancel",
  edit: "i-booking-edit",
  descriptionContent: "i-booking-description",
};

export default class MyBookingsOffice365 extends React.Component {

  where;

  constructor(props) {
    super(props);

    this.state = component.newState({
      bookings: [],
      isWorking: true,
      units: []
    });
  }

  componentDidMount() {
    this._mounted = true;
    this._init();
    component.own(this, [
      Topic.subscribe(Topic.RenderBookingListOffice365, () => {
        this._mounted && this.setState({isWorking: true})
        this._init();
      })
    ])
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.bookingDateFilter !== this.props.bookingDateFilter) {
      this.setState({isWorking: true});
      this._init();
    }
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.bookingDateFilter !== this.props.bookingDateFilter) {
      this.setState({isWorking: true});
      this._init();
    }
  }

  _getBookings = () => {
    let currentDateTime = moment(Date.now()).add(1,"milliseconds").toISOString();
    const params = {
      currentDateTime: currentDateTime,
      bookingType: "hotel",
      bookingDateFilter: this.props.bookingDateFilter
    }

    return getBookings(this.props.bookingSystem, params).catch(e => {
      console.error(e);
      throw e;
    });
  }

  _getUserBookings() {
    return this._getBookings().then(scheduleResult => {
      let bookings = [], items;
      const value = scheduleResult && scheduleResult.value && scheduleResult.value.length > 0;
      if (value) items = scheduleResult.value;
      if (items) {
        items.forEach((item)=> {
          bookings.push(item);
        })
      }
      this._mounted && this.setState({
        bookings: bookings,
        isWorking: false
      });
    }).catch(e => {
      console.error(e);
      throw e;
    });    
  }

  _init =async()=> {
    return await this._getUserBookings();
  }

  makeBookingList = (bookings) => {
    const myBookingsList = [];
    bookings.forEach((booking) => {
      myBookingsList.push(
        <MyBookingsCard 
          key={booking.id}
          booking={booking}
          units={this.state.units}
          bookingDateFilter={this.props.bookingDateFilter}
          bookingSystem={this.props.bookingSystem}
        />
      );
    });

    return myBookingsList;
  }

  renderBookingCards() {
    const i18n = Context.getInstance().i18n;
    const { bookings } = this.state;
    const bookingList = this.makeBookingList(bookings);

    return bookingList && bookingList.length > 0 ? (
      <ul className={CSS.bookingCardList}>
        {bookingList}
      </ul>
    ) : (
      <div style={{ padding: '0.7rem 1rem' }}>{i18n.more.bookWorkspace.noBookings}</div>
    );
  }

  renderWorking() {
    return (<Loader sizeRatio={1} style={{ marginTop: '3rem' }} />);
  }

  render() {
    const { isWorking } = this.state;
    return isWorking ? this.renderWorking() : this.renderBookingCards();
  }
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

class MyBookingsCard extends React.Component {
  _componentId;
  _itemRef;
  bookingSystem = getHotelBookingSystem();

  constructor(props) {
    super(props);
    this._componentId = component.nextId("booking-");
    this._itemRef = React.createRef();
    this.state= {
      unitFeature: null,
      isLocationChange: this._isLocationChange(),
      status: "none",
      popoverOpen: false,
      popoverType: null
    }
  }

  async componentDidMount() {
    const booking = this.props.booking;
    const unitId = booking && booking.extensions && booking.extensions[0].unitId;
    let unitFeature = await workspaceReservationUtil.queryUnitByUnitId(unitId);
    if (unitFeature && unitFeature.features && unitFeature.features.length > 0) {
      unitFeature = unitFeature.features[0];
      this.setState({
        unitFeature: unitFeature
      })
    }
  }

  _isLocationChange =()=> {
    const booking = this.props && this.props.booking;
    const extensions = booking && booking.extensions && booking.extensions[0];
    const unitId = extensions && extensions.unitId;
    const unc = Context.instance.session.unitNameCache;
    if (unc && unc.defaultNamesPerUnitId && unitId) {
      const origUnitName = unc.defaultNamesPerUnitId[unitId];
      const newUnitName = booking && booking.location && booking.location.displayName;
      if (origUnitName !== newUnitName) return true
      return false;
    }
  }

  _statusClicked = async (status) => {
    if (status === "declined") {
      const i18n = Context.instance.i18n;
      const options = {
        title: i18n.more.bookWorkspace.declineBookingO365Title,
        message: i18n.more.bookWorkspace.declineBookingO365Msg,
        okLabel: i18n.general.ok,
        showOkCancel: true,
        hideCancel : true,
        closeOnOK: true
      };
      ModalController.confirm(options);
      return;
    } else if (status === "mismatchEmail") {
      const booking = this.props.booking;
      const unitName = booking && booking.location && booking.location.displayName;
      const scheduleEmail = booking && booking.extensions && booking.extensions[0] && booking.extensions[0].scheduleEmail;
      let attendeeEmails = [], attendeeEmailsStr;
      for (let i=0;i<booking.attendees.length;i++) {
        const emailAddress = booking.attendees[i].emailAddress.address;
        attendeeEmails.push(emailAddress);
        attendeeEmailsStr = attendeeEmails.join(attendeeEmails)
      }      
      const i18n = Context.instance.i18n;
      let msg = i18n.meetingRooms.emailMismatch.message;
      msg = msg.replace("{scheduleEmail}", scheduleEmail);
      msg = msg.replace("{unitName}", unitName);
      msg = msg.replace("{attendeeEmails}", attendeeEmailsStr)

      ModalController.showError({
        title: i18n.general.information,
        className: "i-portrait-access-hotel-error",
        errors: {
          generic: i18n.meetingRooms.emailMismatch.caption,
          detailed: [msg]
        }
      });
    }
  }

  _bookingCardClicked = async (e,considerDeclined) => {
    const isLocationChange = this.state.isLocationChange;
    const declined = Office365.wasDeclined( this.props.booking);
    if (isLocationChange || (considerDeclined && declined)) {
      const i18n = Context.instance.i18n;
      const options = {
        title: (isLocationChange ? i18n.meetingRooms.locationChange.caption : i18n.more.bookWorkspace.declineBookingO365Title),
        message: (isLocationChange ? i18n.meetingRooms.locationChange.message : i18n.more.bookWorkspace.declineBookingO365Msg),
        okLabel: i18n.general.ok,
        showOkCancel: true,
        hideCancel : true,
        closeOnOK: true
      };
      ModalController.confirm(options);
      return;
    }
    const booking = this.props.booking;
    const unitId = booking && booking.extensions && booking.extensions[0].unitId;
    let unitFeature = await workspaceReservationUtil.queryUnitByUnitId(unitId);
    if (unitFeature && unitFeature.features && unitFeature.features.length > 0) {
      unitFeature = unitFeature.features[0];
      this.setState({
        unitFeature: unitFeature
      })
    }

    const source = Context.instance.aiim.datasets.units.getSource();
    const searchResult = source.makeSearchResult(null, unitFeature);
    Topic.publish(Topic.ShowSearchResult, {
      sourceKey: source.key,
      searchResult: searchResult,
      zoom: true,
      highlight: true,
      trackRecent: true,
      componentId: this._componentId
    });
  }

  _cancelClicked = (type) => {
    const booking = this.props.booking;
    const unitName = booking && booking.location && booking.location.displayName;
    const eventId = booking && booking.id;
    const seriesMasterId = booking && booking.seriesMasterId;
    const isRecurring = booking.recurrence ? true : false;
    const i18n = Context.getInstance().i18n;
    let msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.message;
    if (unitName) {
      msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.newMessage;
      msg = msg.replace("{unit}",unitName);
    }
    if (isRecurring) {
      msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.seriesMessage;
      if (type === "occurrence") msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.occurrenceMessage;
      msg = msg.replace("{unit}", unitName);
    }

    const options = {
      title: i18n.more.bookWorkspace.checkInOut.cancelBooking.modalTitle,
      message: msg,
      okLabel: i18n.more.bookWorkspace.checkInOut.cancelBooking.yes,
      cancelLabel: i18n.more.bookWorkspace.checkInOut.cancelBooking.no,
      showOKCancel: true,
      closeOnOK: true,
      closeOnCancel: true
    };
    ModalController.confirm(options)
      .then((result) => {
        if (result && result.ok) {
          return new Promise((resolve, reject) => {
            let currentDateTime = moment(Date.now()).add(1,"milliseconds").toISOString();
            const params = {
              currentDateTime: currentDateTime,
              bookingType: "hotel",
              bookingDateFilter: this.props.bookingDateFilter
            }
            getBookings(this.props.bookingSystem, params)
            .then((res)=> {
              const value = res && res.value;
              let isBooking = false;
              for (let i=0;i<value.length;i++) {
                if (value[i].id === eventId) {
                  isBooking = true;
                  break;
                }
              }
  
              if (!isBooking) {
                Topic.publish(Topic.ShowToast,{
                  message: i18n.more.bookWorkspace.checkInOut.cancelBooking.bookingNotAvailable
                });
                return "bookingNotAvailable";
              } else {
                let params = {eventId: null}
                if (type === "series") {
                  params.eventId = seriesMasterId;
                } else {
                  params.eventId = eventId
                }
                return cancelBooking(this.props.bookingSystem, params)
              }
            })
            .then((info)=> {
              Topic.publish(Topic.RenderBookingListOffice365, {});
              if (info === "bookingNotAvailable") {
                resolve();
                return;
              };

              this._renderCancelConfirmed(booking); 
              resolve();
            })
            .catch(e => {
              console.error("Couldn't cancel hotel booking", e);
              reject(e);
            });
          })
        }
      })     
      .catch((e) => {
        console.error(e);
      });
  }

  componentWillUnmount(){
    component.componentWillUnmount(this);
  }

  _onKeyDown = (event) => {
    const ENTER = 13;
    const SPACE = 32;

    if (event.keyCode === ENTER || event.keyCode === SPACE) {
      event.preventDefault();
      this._bookingCardClicked(event);
    }
  }

  _getRecurrenceIcon(mStartTime, mEndTime, isAllDay, recurrence) {  

    if(!recurrence) return null;

    const pattern = recurrence && recurrence.pattern;
    const range = recurrence && recurrence.range;
    const daysofWeek = pattern && pattern["daysOfWeek"];
    const endDate = range["endDate"];
    const type = pattern["type"];

    const daysInIndex = [];
    if(daysofWeek && daysofWeek.length > 0) {
      daysofWeek.forEach((day)=> {
        if(day === 'sunday') daysInIndex.push(0);
        if(day === 'monday') daysInIndex.push(1);
        if(day === 'tuesday') daysInIndex.push(2);
        if(day === 'wednesday') daysInIndex.push(3);
        if(day === 'thursday') daysInIndex.push(4);
        if(day === 'friday') daysInIndex.push(5);
        if(day === 'saturday') daysInIndex.push(6);
      })
    }
    const info = {
      enabled: true,
      endDate: endDate,
      type: type,
      days: daysInIndex
    }
    const tooltip = workspaceReservationUtil.formatRecurringDates(info, 
      moment(mStartTime), moment(mEndTime), isAllDay);

    return (
      <span title={tooltip}>
        <RecurrenceIcon/>
      </span>
    )
  }

  _togglePopover = (type) => {
    this.setState({
      popoverOpen: type != null ? true : !this.state.popoverOpen,
      popoverType: type
    });
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const booking = this.props.booking;
    const levels = Context.getInstance().aiim.datasets.levels;
    const isLocationChange = this.state.isLocationChange;
    const declined = Office365.wasDeclined(booking);
    const scheduleEmail = booking && booking.extensions && booking.extensions[0] && booking.extensions[0].scheduleEmail;
    const statusObj = Office365.getEventStatus(booking, scheduleEmail);
    let status = statusObj && statusObj.status;
    const statusDetails = validateUtil.getStatusIconMsg(statusObj); 
    const statusIcon = statusDetails && statusDetails.icon;
    const statusMsg = statusDetails && statusDetails.msg;
    let borderStyle = statusDetails && statusDetails.borderStyle;

    // Field values to display
    const checkInDate = booking && booking.start;
    const checkOutDate = booking && booking.end;

    const o365toDateObj = dateUtil.O365toDate(checkInDate.dateTime, checkOutDate.dateTime);
    const fromDateTime = o365toDateObj.fromDateTime;
    const toDateTime = o365toDateObj.toDateTime;
    
    const unitName = booking && booking.location && booking.location.displayName;
    const levelId = booking && booking.extensions && booking.extensions[0].levelId;

    // Level/Facility info
    const levelData = levels.getLevelData(levelId); 
    const levelName = levelData && levelData.levelName;
    const facilityName = levelData && levelData.facilityName;
    const template = i18n.more.bookWorkspace.levelDescription;
    const description = !isLocationChange && stringFormatter(template, {
      level: levelName,
      facility: facilityName
    });

    let statusTitle;
    if (isLocationChange) statusTitle = i18n.meetingRooms.locationChange.message;
    else if (declined) statusTitle = i18n.more.bookWorkspace.declineBookingO365Msg;
    else if (status && status === "mismatchEmail") statusTitle = i18n.meetingRooms.emailMismatch.caption;

    // Format a date string from the start and end times

    const fromDate = o365toDateObj.fromDate;
    const toDate = o365toDateObj.toDate;
    const isAllDay = dateUtil.isAllDay(fromDate.getTime(), toDate.getTime());
    const formattedDate = workspaceReservationUtil.formatDate(fromDateTime, isAllDay
      ? toDateTime.subtract(1, "millisecond")
      : toDateTime, isAllDay);
    const recurrence = booking.recurrence;
    const bookingType = booking && booking.type;
    const recurrenceIcon = this._getRecurrenceIcon(fromDate, toDate, isAllDay, recurrence, bookingType);
    const { popoverOpen, popoverType } = this.state;
    const isRecurring = recurrence ? true : false;

    let marginEditCss = {marginLeft: "7rem"}
    const isRtl = Context.getInstance().uiMode.isRtl;
    if(isRtl) marginEditCss = {marginRight: "7rem"};

    const textAlign = isRtl ? "right" : "left";

    const cancelButton = (
      <button
        className={CSS.cancel}
        data-id={"cancel"}
        onClick={() => isRecurring ? this._togglePopover("cancel") : this._cancelClicked()}
      >
        <XIcon />
        {i18n.general.cancel}
      </button>
    );

    const cancelDropdownButton = (
      <RecurrenceDropdown
        type="cancel"
        open={popoverOpen && popoverType === "cancel"}
        targetEl={cancelButton}
        onRequestClose={this._togglePopover}
        onSelection={(type) => {
          this._cancelClicked(type);
          this._togglePopover();
        }} />
    )

    const rescheduleButton = (
      <button
        style={marginEditCss}
        className={CSS.edit}
        data-id={"cancel"}
        onClick={() => this.scheduleClicked(isAllDay)}
        disabled={isLocationChange ||(status && status === "mismatchEmail")}
      >
        <PencilIcon/>
        {i18n.more.bookWorkspace.checkInOut.rescheduleBooking.caption}
      </button>
    )

    if (isLocationChange ||(status && status === "mismatchEmail")) borderStyle = {borderLeft: "1px #dfdfdf solid"}
    return (
      <li className={CSS.bookingCard}>
        <div className="i-book-card-container" style={borderStyle}>
          <div
            id={this._componentId}
            className={CSS.descriptionContent}
            ref={this._itemRef}
            role="button"
            tabIndex="0"
            onClick={this._bookingCardClicked}
            onKeyDown={this._onKeyDown}
          >
            <h3 className={CSS.bookingInfoLine} style={{justifyContent: "space-between"}}>
              <span>
                <ClockIcon size={16}/>
                {formattedDate}
              </span>
              <span>
                {isRecurring && recurrenceIcon}
              </span>
            </h3>

            {!isLocationChange && ( 
              <>
                <h4 className={CSS.bookingInfoLine}>
                  <PinIcon />
                  {unitName}
                </h4>
                <h4 className={CSS.locationDescription} style={{paddingLeft: "1.3rem", paddingRight: "1.4rem", marginBottom: "0rem"}}>{description}</h4>
              </>
            )}

            {isLocationChange && ( 
              <Tooltip style={{textAlign: textAlign}} placement="top" positionFixed={true}
                title={statusTitle}>
                <div
                  role="button"
                  tabIndex="0"
                  onClick={(e) => {
                    e.stopPropagation();
                    this._bookingCardClicked(e,true)
                  }}
                >
                  <h4 className="i-booking-info-line i--warn-location-change">
                    <PinIcon />
                    {unitName}
                    <span><WarningIcon className="i--warn" size={16} /></span>
                  </h4>
                  <h4 className={CSS.locationDescription+" i--warn-location-change"}>{description}</h4>
                </div>
              </Tooltip>
            )}
           
            {!isLocationChange && !statusTitle && (
                <div className={CSS.bookingInfoLine}>
                  <h4>{statusIcon}</h4>
                  <h4>{statusMsg}</h4>
                </div>
              )
            }

            {!isLocationChange && statusTitle && (
              <Tooltip style={{textAlign: textAlign}} placement="top" positionFixed={true}
                title={statusTitle}>
                <div
                  role="button"
                  tabIndex="0"
                  onClick={(e) => {
                    e.stopPropagation();
                    this._statusClicked(status)
                  }}
                >
                  <div className={CSS.bookingInfoLine}>
                    <h4>{statusIcon}</h4>
                    <h4>{statusMsg}</h4>
                  </div>
                </div>
              </Tooltip>
              )
            }
          </div>
          <div className={CSS.actionGroup}>
            <span></span>
            <span style={{display: "flex"}}>
            {!recurrence && rescheduleButton}
            {cancelDropdownButton}
            </span>
          </div>
        </div>
      </li>
    );
  }

  getFeature() {
    return (this.props.item.getFeature());
  }

  checkAvailability = async(checkInDate, checkOutDate, allDay, options) => {    
    const booking = this.props && this.props.booking;
    const units = Context.instance.aiim.datasets.units;
    const item = new ItemReference();
    const unit = this.state.unitFeature;

    item._fromFeature(units.getSource().key, unit);
    const o365toDateObj = dateUtil.O365toDate(booking.start.dateTime, booking.end.dateTime);

    const task = {
      checkInDate: checkInDate,
      checkOutDate:checkOutDate,
      allDay: allDay,
      options: options,
      unit: unit,
      unitName: this.state.unitName,
      levelName: this.state.levelName,
      facilityName: this.state.facilityName,
      scheduleEmail: this.state.scheduleEmail,
      bookingSystem: this.bookingSystem,
      bookingType: "hotel",
      booking,
      item: item,
      operation: "updateBookingTime",
      eventId: this.state.eventId,
      client: this.props.client,
      renderBookingConfirmed: this.renderBookingConfirmed,
      origBooking: o365toDateObj
    }

    task.retry=()=> {
      this.checkAvailability(checkInDate, checkOutDate, allDay, options);
    }
    const response = await validateUtil.verifyAndBook(task);
    if (!response || (response && !response.ok)) return;
  }
  
  _renderCancelConfirmed(booking) {
    const unitName = booking && booking.location && booking.location.displayName;

    const node = document.createElement("div");
    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node);
      }
    };

    document.body.appendChild(node);
    ReactDOM.render(
      <BookingCancel
        bookingSystemType={getHotelBookingSystemType()}
        unitName={unitName}        
        closePopup={onClose}
        data={booking}/>, node);
  }
  
  renderBookingConfirmed(data, params, task) {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <BookingConfirmed
        bookingSystemType={getHotelBookingSystemType()}
        unitName={task.unitName}
        levelName={task.levelName}
        facilityName={task.facilityName}
        closePopup={onClose}
        data={data}
        unit={params && params.unit}
        params={params}
      />
    ), node);
  }

  processScheduleClick = true;

  scheduleClicked = async (isAllDay) => {
    if (!this.processScheduleClick) return;
    try {
      this.processScheduleClick = false;
    const booking = this.props.booking;
    const i18n = Context.instance.i18n;
    const info = await workspaceReservationUtil.getReScheduleInfo(booking, "hotel");
    if (!info) {
      const i18n = Context.getInstance().i18n;
      Topic.publish(Topic.RenderBookingListOffice365, {});
      Topic.publish(Topic.ShowToast,{
        message: i18n.more.bookWorkspace.checkInOut.cancelBooking.bookingNotAvailable
      });
      return;
    }
      // end date for all-day bookings (M365) is saved as 12 am the following day
      // subtract 1 second from all-day end date
      if (isAllDay) {
        info.when.end.date = moment(info.when.end.date).subtract(1, "millisecond").valueOf();
      }
    const controller = new ModalController();
    let title = i18n.meetingRooms.schedule.captionPattern;
    title = title.replace("{room}",info.item.name);
    const modalProps = {
      className: "i-modal-confirm i-modal-schedule",
      title: title,
      cancelLabel: i18n.general.close,
      showOKCancel: true,
      hideOK: true
    };

    const content = (
      <Schedule 
        bookingType="hotel"
        item={info.item} 
        start={info.start} 
        when={info.when} 
        originalReservation={{booking, attributes: null}}
        operation={info.operation}
        isOngoingBooking={info.isOngoingBooking}
        onBookClicked={selectedWhen => {
          this._rescheduleBooking(selectedWhen);
          controller.close();
        }}/>
    )
    controller.show(modalProps,content);
    } catch(ex) {
      console.error(ex)
    } finally {
      setTimeout(()=> {
        this.processScheduleClick = true;
      },200)
    }
  }

  getEpochCurrentTime =()=> {
    const currentDateTime = new Date();
    var unix_seconds = (new Date(currentDateTime)).getTime();
    return unix_seconds;
  }

  _rescheduleBooking =async (options)=> {

    const booking = this.props.booking;
    const extension = booking && booking.extensions && booking.extensions[0];
    const areaId = extension.areaId;
    const scheduleEmail = extension.scheduleEmail;
    const eventId = booking.id;
    const originalReservation = options.originalReservation;

    const aiim = Context.instance.aiim;
    const levels = aiim.datasets && aiim.datasets.levels;
    let levelName, facilityName;
    if (levels) {
      const levelId = extension.levelId;
      const levelData = levels.getLevelData(levelId);
      levelName = levelData.levelName;
      facilityName = levelData.facilityName;
    }

    const area = await workspaceReservationUtil.getArea(areaId);
    const areaAttr = area && area.attributes;
    const areaName = getAttributeValue(areaAttr, FieldNames.AREA_NAME)
    const unitAttr = this.state.unitFeature.attributes;
    const spaceType = getAttributeValue(unitAttr, FieldNames.UNITS_USE_TYPE);
    const unitName = getAttributeValue(unitAttr, FieldNames.NAME);

    const fromDate = new Date(moment(options.start.date));
    const toDate = new Date(moment(options.end.date));
    const fromDateTime = moment(options.start.date);
    const endDateTime = moment(options.end.date);
    const isAllDay = options && options.duration === "allDay";

    this.setState({
      unitName: unitName,
      levelName: levelName,
      facilityName: facilityName,
      scheduleEmail: scheduleEmail,
      eventId: eventId
    })

    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <Provider store={Rdx.store}>
        <BookingDetails
          operation="updateBookingTime"
          isOngoingBooking={options.isOngoingBooking}
          area={area}
          areaName={areaName}
          areaId={areaId}
          spaceType={spaceType}
          scheduleEmail={scheduleEmail}
          unitName={unitName}
          levelName={levelName}
          facilityName={facilityName}
          startDate={fromDate}
          startTime={fromDateTime}
          endTime={endDateTime}
          endDate={toDate}
          allDay={isAllDay}
          checkAvailability={this.checkAvailability}
          isBookWorkspacePanel={true}
          unitFeature={this.state.unitFeature}
          originalReservation={{attributes: null, booking}}
          closePopup={onClose}
        />
      </Provider>
    ), node);
  }
}
